import { css } from '@emotion/react';
import { tokens } from '@flysas-tech/commercial-ui';
import { DateTime } from 'luxon';
import { ReactElement } from 'react';

const styles = {
  infoContainer: css`
    display: flex;
    flex-direction: column;
    gap: ${tokens.dimension['space-1']};
  `,
  infoRow: css`
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
      flex-direction: row;
    }
  `,
  infoItem: css`
    position: relative;

    @media (min-width: 768px) {
      padding: 0 12px;
      font-size: ${tokens.fontSize.paragraph['paragraph-2']};

      &:not(:last-child)::after {
        content: '';
        position: absolute;
        right: 0;
        height: 16px;
        width: 1px;
        background-color: #ccc;
        top: 50%;
        transform: translateY(-50%);
      }

      :first-of-type {
        padding-left: 0;
      }
    }
  `,
  greyBoxWrapper: css`
    padding: 12px 0;
  `,
  greyBox: css`
    background-color: ${tokens.color.gray['100']};
    padding: 16px;
    display: flex;
    border-radius: 8px;
  `,
  flightTime: css`
    font-size: ${tokens.fontSize.paragraph['paragraph-4']};
    font-weight: 700;
  `,
};

type Info = { info: string[] };

export const FlightTime = ({ dateTime }: { dateTime: DateTime<true> }) => {
  return <div css={styles.flightTime}>{dateTime.toFormat('HH:mm')}</div>;
};

export const SegmentFlightInfo = ({ info, duration }: { duration: string } & Info) => {
  return (
    <GrayBox>
      <div css={styles.infoContainer}>
        <div>{duration}</div>
        <InfoRow info={info} />
      </div>
    </GrayBox>
  );
};

export const InfoRow = ({ info }: Info) => {
  return (
    <div css={styles.infoRow}>
      {info.map(item => (
        <span key={item} css={styles.infoItem}>
          {item}
        </span>
      ))}
    </div>
  );
};

export const GrayBox = ({ children }: { children: ReactElement | ReactElement[] }) => {
  return (
    <div css={styles.greyBoxWrapper}>
      <div css={styles.greyBox}>{children}</div>
    </div>
  );
};
